window.env = function (variable) {
    return process.env[variable]
}
